import $ from "jquery";
import { csl } from "@@assets/scripts/common";
import { initArticle } from "@@components/work/dataArticle";

function addCategorySection(vuw, key, name, list) {
	const vuwName = `${key}Section`;
	
	vuw.add(`${key}Section`, {
		selector() {
			if(this.container.$self) {
				const id = `category_${key}_section`;
				const $content = $("<div/>").addClass("content").attr({ id })
				.append(
					$("<h2/>").addClass("section-title").text(name),
					$("<div/>").addClass("section-body"),
					$("<footer/>").addClass("section-footer").append(
						$("<div/>").addClass("btns")
						.append(
							$("<a/>").addClass("btn btn-go-selftop icon-after").attr({
								href: `#${id}`,
								"data-icon": "arrow-t"
							}).append(
								$("<span/>").text(`${name}のトップへ戻る`)
							)
						)
					)
				);
				
				this.setProp({ $content });
				
				return $("<section/>").addClass(
					"section category-section"
				).attr({ "data-section": key }).append(
					$content
				).appendTo(
					this.container.$self
				);
			}
		}
	});
	
	const { module, template } = vuw;
	
	vuw.get(vuwName).add("body", {
		vuwType: "colony",
		selector() {
			if(this.container.$content) {
				return this.container.$content.children(".section-body");
			}
		},
		module,
		autoLoad: false,
		showPager: false,
		initArticle,
		onReady($self) {
			if( $self && Array.isArray(list) && template ) {
				this.setArticleTemplate(template);
				return this.initList(list);
			}
		}
	});
	
	csl.log.orange(`* added ${vuwName}`, { list });
}

export default addCategorySection;
